import React, { useState } from 'react'
import { Link, usePage } from '@inertiajs/react'

import { FaBroom } from 'react-icons/fa6'
import { BsTrash2Fill } from 'react-icons/bs'
import { FaAirFreshener } from 'react-icons/fa'
import { GiPaperBagCrumpled } from 'react-icons/gi'

import Layout from '@/Shared/Layout'
import CardContainer from '@/Shared/UI/CardContainer'
import StatsCard from '@/Shared/UI/StatsCard'
import TableFilter from '@/Shared/TableFilter'
import Icon from '@/Shared/Icon'

import TableRow from '@/Pages/Consumables/Shared/TableRow'

const Index = () => {
    const {
        id,
        hospital_name,
        brooms,
        brooms_arrived_date,
        wiper,
        wiper_arrived_date,
        normal_waste_21_bag,
        normal_waste_21_bag_arrived_date,
        normal_waste_30_bag,
        normal_waste_30_bag_arrived_date,
        normal_waste_39_bag,
        normal_waste_39_bag_arrived_date,
        furniture_dusters,
        furniture_dusters_arrived_date,
        disinfectant,
        disinfectant_arrived_date,
        hand_wash_liquid,
        hand_wash_liquid_arrived_date,
        air_freshener,
        air_freshener_arrived_date,
        mop_pads,
        mop_pads_arrived_date,
        liquid_toilet_cleaner,
        liquid_toilet_cleaner_arrived_date,
        floor_mops_standard,
        floor_mops_standard_arrived_date,
        hand_wash_dispenser,
        hand_wash_dispenser_arrived_date,
        floor_cleaning_towels,
        floor_cleaning_towels_arrived_date,
        disposable_bed_sheets,
        disposable_bed_sheets_arrived_date,
        air_freshener_2,
        air_freshener_2_arrived_date,
        air_freshener_3,
        air_freshener_3_arrived_date,
        consumedQuantity,
        remainingQuantity,
        percentage,
        auth: {
            user: { role }
        }
    } = usePage().props

    const [values, setValues] = useState({
        brooms_arrived_date,
        wiper_arrived_date,
        normal_waste_21_bag_arrived_date,
        normal_waste_30_bag_arrived_date,
        normal_waste_39_bag_arrived_date,
        furniture_dusters_arrived_date,
        hand_wash_liquid_arrived_date,
        disinfectant_arrived_date,
        air_freshener_arrived_date,
        mop_pads_arrived_date,
        liquid_toilet_cleaner_arrived_date,
        floor_mops_standard_arrived_date,
        hand_wash_dispenser_arrived_date,
        floor_cleaning_towels_arrived_date,
        disposable_bed_sheets_arrived_date,
        air_freshener_2_arrived_date,
        air_freshener_3_arrived_date,
    })

    return (
        <div>
            <div className="mb-4 flex items-center justify-between">
                <h1 className="text-3xl font-bold">
                    <span className="text-indigo-400">{hospital_name}</span> Consumable
                </h1>

                <div className="flex flex-row gap-x-2">
                    <TableFilter exportRoute="consumed.export" />

                    {role === '1' && (
                        <Link
                            className="btn-indigo focus:outline-none"
                            href={route('consumable.edit', id)}
                        >
                            <span>Update</span>
                        </Link>
                    )}
                </div>
            </div>

            <CardContainer>
                <StatsCard
                    title="Brooms (1.5 Kg)"
                    value={`${consumedQuantity[0]}/${brooms}`}
                    icon={FaBroom}
                    remaining={remainingQuantity[0]}
                />

                <StatsCard
                    title="Wiper"
                    value={`${consumedQuantity[1]}/${wiper}`}
                    icon={() => <Icon name="wiper" />}
                    remaining={remainingQuantity[1]}
                />

                <StatsCard
                    title="Normal Waste Bags 21x28 (KG)"
                    value={`${consumedQuantity[2]}/${normal_waste_21_bag}`}
                    icon={() => <Icon name="normal_waster_21" />}
                    remaining={remainingQuantity[2]}
                />

                <StatsCard
                    title="Normal Waste Bags 30x30 (KG)"
                    value={`${consumedQuantity[3]}/${normal_waste_30_bag}`}
                    icon={BsTrash2Fill}
                    remaining={remainingQuantity[3]}
                />

                <StatsCard
                    title="Normal Waste Bags 39x45 (KG)"
                    value={`${consumedQuantity[4]}/${normal_waste_39_bag}`}
                    icon={GiPaperBagCrumpled}
                    remaining={remainingQuantity[4]}
                />

                <StatsCard
                    title="Furniture Dusters"
                    value={`${consumedQuantity[5]}/${furniture_dusters}`}
                    icon={() => <Icon name="furniture_duster" />}
                    remaining={remainingQuantity[5]}
                />

                <StatsCard
                    title="Disinfectant (2.75 Lit Bottle)"
                    value={`${consumedQuantity[6]}/${disinfectant}`}
                    icon={() => <Icon name="disinfectant" />}
                    remaining={remainingQuantity[6]}
                />

                <StatsCard
                    title="Hand Wash Liquid (Liters)"
                    value={`${consumedQuantity[7]}/${hand_wash_liquid}`}
                    icon={() => <Icon name="hand_wash_liquid" />}
                    remaining={remainingQuantity[7]}
                />

                <StatsCard
                    title="Air Freshener (Bottles)"
                    value={`${consumedQuantity[8]}/${air_freshener}`}
                    icon={FaAirFreshener}
                    remaining={remainingQuantity[8]}
                />

                <StatsCard
                    title="Mop Pads"
                    value={`${consumedQuantity[9]}/${mop_pads}`}
                    icon={() => <Icon name="mop_pads" />}
                    remaining={remainingQuantity[9]}
                />

                <StatsCard
                    title="Liquid Toilet Cleaner (900 ml Bottle)"
                    value={`${consumedQuantity[10]}/${liquid_toilet_cleaner}`}
                    icon={() => <Icon name="liquid_toilet_cleaner" />}
                    remaining={remainingQuantity[10]}
                />

                <StatsCard
                    title="Floor Mops Standard"
                    value={`${consumedQuantity[11]}/${floor_mops_standard}`}
                    icon={() => <Icon name="floor_mop" />}
                    remaining={remainingQuantity[11]}
                />

                <StatsCard
                    title="Hand Wash Dispenser"
                    value={`${consumedQuantity[12]}/${hand_wash_dispenser}`}
                    icon={() => <Icon name="hand_wash" />}
                    remaining={remainingQuantity[12]}
                />

                <StatsCard
                    title="Floor Cleaning Towels"
                    value={`${consumedQuantity[13]}/${floor_cleaning_towels}`}
                    icon={() => <Icon name="floor_cleaning_towels" />}
                    remaining={remainingQuantity[13]}
                />

                <StatsCard
                    title="Disposable Bed Sheets"
                    value={`${consumedQuantity[14]}/${disposable_bed_sheets ?? 0}`}
                    icon={() => <Icon name="bed_sheets" />}
                    remaining={remainingQuantity[14]}
                />

                <StatsCard
                    title="Air Freshener Dispenser (Machines)"
                    value={`${consumedQuantity[15]}/${air_freshener_2 ?? 0}`}
                    icon={FaAirFreshener}
                    remaining={remainingQuantity[15]}
                />

                <StatsCard
                    title="Air Freshener Dispenser Refills"
                    value={`${consumedQuantity[16]}/${air_freshener_3 ?? 0}`}
                    icon={FaAirFreshener}
                    remaining={remainingQuantity[16]}
                />
            </CardContainer>

            <div className="overflow-x-auto rounded bg-white shadow">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="text-left font-bold">
                        <th className="px-6 pb-4 pt-5">Item</th>
                        <th className="px-6 pb-4 pt-5">Stock Available</th>
                        <th className="px-6 pb-4 pt-5">Arrived Date</th>
                        <th className="px-6 pb-4 pt-5">Consumed Quantity</th>
                        <th className="px-6 pb-4 pt-5">Remaining Quantity</th>
                        <th className="px-6 pb-4 pt-5">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <TableRow
                        id={id}
                        title="Brooms (1.5 Kg)"
                        arrivedDate={values.brooms_arrived_date}
                        item="brooms"
                        total={brooms}
                        consumed={consumedQuantity[0]}
                        remaining={remainingQuantity[0]}
                        percentage={percentage[0]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Wiper (Articles)"
                        arrivedDate={values.wiper_arrived_date}
                        item="wiper"
                        total={wiper}
                        consumed={consumedQuantity[1]}
                        remaining={remainingQuantity[1]}
                        percentage={percentage[1]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Normal Waste Bags 21x28 (1 Kg ~ 30 bags)"
                        arrivedDate={values.normal_waste_21_bag_arrived_date}
                        item="normal_waste_21_bag"
                        total={normal_waste_21_bag}
                        consumed={consumedQuantity[2]}
                        remaining={remainingQuantity[2]}
                        percentage={percentage[2]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Normal Waste Bags 30x30 (1 Kg ~ 16 bags)"
                        arrivedDate={values.normal_waste_30_bag_arrived_date}
                        item="normal_waste_30_bag"
                        total={normal_waste_30_bag}
                        consumed={consumedQuantity[3]}
                        remaining={remainingQuantity[3]}
                        percentage={percentage[3]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Normal Waste Bags 39x45 (1 Kg ~ 8 bags)"
                        arrivedDate={values.normal_waste_39_bag_arrived_date}
                        item="normal_waste_39_bag"
                        total={normal_waste_39_bag}
                        consumed={consumedQuantity[4]}
                        remaining={remainingQuantity[4]}
                        percentage={percentage[4]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Furniture Dusters (Articles)"
                        arrivedDate={values.furniture_dusters_arrived_date}
                        item="furniture_dusters"
                        total={furniture_dusters}
                        consumed={consumedQuantity[5]}
                        remaining={remainingQuantity[5]}
                        percentage={percentage[5]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Disinfectant (2.75 Lit Bottle)"
                        arrivedDate={values.disinfectant_arrived_date}
                        item="disinfectant"
                        total={disinfectant}
                        consumed={consumedQuantity[6]}
                        remaining={remainingQuantity[6]}
                        percentage={percentage[6]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Hand Wash Liquid (Liters)"
                        arrivedDate={values.hand_wash_liquid_arrived_date}
                        item="hand_wash_liquid"
                        total={hand_wash_liquid}
                        consumed={consumedQuantity[7]}
                        remaining={remainingQuantity[7]}
                        percentage={percentage[7]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Air Freshener (Bottles)"
                        arrivedDate={values.air_freshener_arrived_date}
                        item="air_freshener"
                        total={air_freshener}
                        consumed={consumedQuantity[8]}
                        remaining={remainingQuantity[8]}
                        percentage={percentage[8]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Mop Pads (Articles)"
                        arrivedDate={values.mop_pads_arrived_date}
                        item="mop_pads"
                        total={mop_pads}
                        consumed={consumedQuantity[9]}
                        remaining={remainingQuantity[9]}
                        percentage={percentage[9]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Liquid Toilet Cleaner (900 ml Bottle)"
                        arrivedDate={values.liquid_toilet_cleaner_arrived_date}
                        item="liquid_toilet_cleaner"
                        total={liquid_toilet_cleaner}
                        consumed={consumedQuantity[10]}
                        remaining={remainingQuantity[10]}
                        percentage={percentage[10]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Floor Mops Standard (Articles)"
                        arrivedDate={values.floor_mops_standard_arrived_date}
                        item="floor_mops_standard"
                        total={floor_mops_standard}
                        consumed={consumedQuantity[11]}
                        remaining={remainingQuantity[11]}
                        percentage={percentage[11]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Hand Wash Dispenser (Articles)"
                        arrivedDate={values.hand_wash_dispenser_arrived_date}
                        item="hand_wash_dispenser"
                        total={hand_wash_dispenser}
                        consumed={consumedQuantity[12]}
                        remaining={remainingQuantity[12]}
                        percentage={percentage[12]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Floor cleaning towels (Articles)"
                        arrivedDate={values.floor_cleaning_towels_arrived_date}
                        item="floor_cleaning_towels"
                        total={floor_cleaning_towels}
                        consumed={consumedQuantity[13]}
                        remaining={remainingQuantity[13]}
                        percentage={percentage[13]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Disposable Bedsheets"
                        arrivedDate={values.disposable_bed_sheets_arrived_date}
                        item="disposable_bed_sheets"
                        total={disposable_bed_sheets}
                        consumed={consumedQuantity[14]}
                        remaining={remainingQuantity[14]}
                        percentage={percentage[14]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Air Freshener Dispenser (Machines)"
                        arrivedDate={values.air_freshener_2_arrived_date}
                        item="air_freshener_2"
                        total={air_freshener_2}
                        consumed={consumedQuantity[15]}
                        remaining={remainingQuantity[15]}
                        percentage={percentage[15]}
                        setValues={setValues}
                    />

                    <TableRow
                        id={id}
                        title="Air Freshener Dispenser Refills"
                        arrivedDate={values.air_freshener_3_arrived_date}
                        item="air_freshener_3"
                        total={air_freshener_3}
                        consumed={consumedQuantity[16]}
                        remaining={remainingQuantity[16]}
                        percentage={percentage[16]}
                        setValues={setValues}
                    />
                    </tbody>
                </table>
            </div>
        </div>
    )
}

Index.layout = page => <Layout title="Consumables Item" children={page} />

export default Index
